module.exports = __webpack_public_path__ + "img/prize-04.dd880426.png";